// extracted by mini-css-extract-plugin
module.exports = {"label":"stylers_label__6kwPO","withBorder":"stylers_withBorder__UQirk","active":"stylers_active__E78om"};